import React from "react";
import classNames from "classnames";
import {
    Popover,
    PopoverTrigger,
    PopoverContent,
} from "@design-system/Popover/Popover";
import { Amount } from "@design-system/Amount/Amount";
import { Separator } from "@design-system/Separator/Separator";
import { TriangleIcon } from "@icons";
import styles from "./TransactionsTotals.module.scss";

interface TransactionSavingsProps {
    count: number;
    cashIn: number;
    cashOut: number;
    total: number;
    average: number;
}

export const TransactionsTotals: React.FC<TransactionSavingsProps> = ({
    count,
    cashIn,
    cashOut,
    total,
    average,
}) => (
    <Popover>
        <PopoverTrigger>
            <div className={styles.triggerButton}>
                <span className="d-block medium text-gray-700">
                    Total:{" "}
                    <Amount
                        amount={total}
                        showNegative
                        className={classNames(
                            total > 0 && styles.positiveAmount,
                        )}
                    />
                </span>
                <TriangleIcon />
            </div>
        </PopoverTrigger>
        <PopoverContent className={styles.popoverContainer}>
            <div className={classNames(styles.line, styles.smallPadding)}>
                <span>Cash in</span>
                <Amount
                    amount={cashIn}
                    className={classNames(cashIn > 0 && styles.positiveAmount)}
                />
            </div>
            <div className={styles.line}>
                <span>Cash out</span>
                <Amount amount={cashOut} showNegative />
            </div>
            <Separator />
            <div className={styles.line}>
                <span>Total</span>
                <Amount
                    amount={total}
                    showNegative
                    className={classNames(total > 0 && styles.positiveAmount)}
                />
            </div>
            <Separator />
            <div className={classNames(styles.line, styles.smallPadding)}>
                <span>Transactions</span>
                <span>{count}</span>
            </div>
            <div className={styles.line}>
                <span>Average</span>
                <Amount amount={average} />
            </div>
        </PopoverContent>
    </Popover>
);
